// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand[data-v-13676854]{color:#fbb040;font-size:40px!important}", ""]);
// Exports
module.exports = exports;
